import basicStyles from './basic'
import modernStyles from './modern'
import classicStyles from './classic'
import { Resume } from '@/types/resume/v1'
import { IParagraphStylePropertiesOptions, IStylesOptions } from 'docx'
import { getResumePageConfig } from './properties/page'
import { getParagraphStyle } from './properties/paragraph'
import { IPageConfig } from './types'

const StyleMap: Record<string, (paragraph: IParagraphStylePropertiesOptions) => IStylesOptions> = {
  basic: basicStyles,
  basicalt: basicStyles,
  classic: classicStyles,
  modernprofessional: modernStyles,
  modernstudent: modernStyles,
}

export function getStyleConfig(meta?: Resume.Meta): {
  styles: IStylesOptions,
  pageConfig: IPageConfig
} {
  const templateName = meta?.template || 'basic'

  const styleConfig = StyleMap[templateName] || basicStyles

  const paragraphStyle = getParagraphStyle(meta)

  return {
    styles: styleConfig(paragraphStyle),
    pageConfig: getResumePageConfig(meta),
  }
}
